import { render } from "./Pet.vue?vue&type=template&id=37433f15"
import script from "./Pet.vue?vue&type=script&lang=js"
export * from "./Pet.vue?vue&type=script&lang=js"
script.render = render

export default script